/* Load Modules */
import { memoize } from "lodash";

/* Load Constants */
import {
    checkRenderForProvider,
    checkDefaultForType
} from "../../../../../../../utils/utils";
import * as SETTINGS_CONSTS from "./SettingsConfiguratinSection.constants";

export const defaultValues = memoize(
    ({ schema, country, form_values, regions }) => {
        let defaults = {};

        Object.keys(schema.properties).map(item => {
            defaults[item] =
                checkRenderForProvider(item, schema.properties) &&
                schema.properties[item]
                    ? schema.properties[item].hasOwnProperty("default")
                        ? schema.properties[item].convert
                            ? schema.properties[item].default / 100
                            : schema.properties[item].default
                        : checkDefaultForType(
                              schema.properties[item].type,
                              undefined,
                              schema.required && schema.required.includes(item)
                          )
                    : null;
        });

        defaults["bingo"] = null;
        defaults["spins"] = null;
        defaults["lotto"] = null;
        defaults["keno"] = null;

        const settingsFormDefinition = SETTINGS_CONSTS.SETTINGS_FORM_DEFINITION(
            country,
            undefined,
            (form_values && form_values["points_system"]) || false,
            form_values,
            schema,
            regions
        );
        /*
        // REMOVE COMMUNICATION PROTOCOLS
        if (
            settingsFormDefinition[
                SETTINGS_CONSTS.SCHEMA_NAMES.COMMUNICATION_PROTOCOLS
            ].definition["items"].length > 0
        ) {
            defaults["communication_protocols"] = [
                settingsFormDefinition[
                    SETTINGS_CONSTS.SCHEMA_NAMES.COMMUNICATION_PROTOCOLS
                ].definition["items"][0].value
            ];
        } else {
            defaults["communication_protocols"] = [];
        }
         */

        return defaults;
    }
);

export const bingoDefaultValues = memoize(({ schema }) => {
    let defaults = {};

    Object.keys(schema.definitions.$bingo.properties).map(item => {
        defaults[item] =
            checkRenderForProvider(
                item,
                schema.definitions.$bingo.properties
            ) &&
            schema.definitions.$bingo.properties[item] &&
            "default" in schema.definitions.$bingo.properties[item]
                ? (schema.definitions.$bingo.properties[item].convert
                      ? schema.definitions.$bingo.properties[item].default / 100
                      : schema.definitions.$bingo.properties[item].default) ||
                  checkDefaultForType(
                      schema.definitions.$bingo.properties[item].type,
                      "enum" in schema.definitions.$bingo.properties[item]
                          ? schema.definitions.$bingo.properties[item].enum
                          : undefined
                  )
                : null;
    });

    return defaults;
});

export const spinsDefaultValues = memoize(({ schema }) => {
    let defaults = {};

    Object.keys(schema.definitions.$spins.properties).map(item => {
        defaults[item] =
            checkRenderForProvider(
                item,
                schema.definitions.$spins.properties
            ) &&
            schema.definitions.$spins.properties[item] &&
            "default" in schema.definitions.$spins.properties[item]
                ? (schema.definitions.$spins.properties[item].convert
                      ? schema.definitions.$spins.properties[item].default / 100
                      : schema.definitions.$spins.properties[item].default) ||
                  checkDefaultForType(
                      schema.definitions.$spins.properties[item].type
                  )
                : null;
    });

    return defaults;
});

export const lottoDefaultValues = memoize(({ schema }) => {
    let defaults = {};

    Object.keys(schema.definitions.$lotto.properties).map(item => {
        defaults[item] =
            checkRenderForProvider(
                item,
                schema.definitions.$lotto.properties
            ) &&
            schema.definitions.$lotto.properties[item] &&
            "default" in schema.definitions.$lotto.properties[item]
                ? (schema.definitions.$lotto.properties[item].convert
                      ? schema.definitions.$lotto.properties[item].default / 100
                      : schema.definitions.$lotto.properties[item].default) ||
                  checkDefaultForType(
                      schema.definitions.$lotto.properties[item].type,
                      "enum" in schema.definitions.$lotto.properties[item]
                          ? schema.definitions.$lotto.properties[item].enum
                          : undefined
                  )
                : null;
    });

    return defaults;
});

export const kenoDefaultValues = memoize(({ schema }) => {
    let defaults = {};

    Object.keys(schema.definitions.$keno.properties).map(item => {
        defaults[item] =
            checkRenderForProvider(
                item,
                schema.definitions.$keno.properties
            ) &&
            schema.definitions.$keno.properties[item] &&
            "default" in schema.definitions.$keno.properties[item]
                ? (schema.definitions.$keno.properties[item].convert
                      ? schema.definitions.$keno.properties[item].default / 100
                      : schema.definitions.$keno.properties[item].default) ||
                  checkDefaultForType(
                      schema.definitions.$keno.properties[item].type,
                      "enum" in schema.definitions.$keno.properties[item]
                          ? schema.definitions.$keno.properties[item].enum
                          : undefined
                  )
                : null;
    });

    return defaults;
});

export const pointSystemDefaultValues = memoize(({ schema }) => {
    let defaults = {};

    Object.keys(schema.definitions.$point_system.properties).map(item => {
        defaults[item] =
            checkRenderForProvider(
                item,
                schema.definitions.$point_system.properties
            ) &&
            schema.definitions.$point_system.properties[item] &&
            "default" in schema.definitions.$point_system.properties[item]
                ? (schema.definitions.$point_system.properties[item].convert
                      ? schema.definitions.$point_system.properties[item].default / 100
                      : schema.definitions.$point_system.properties[item].default) ||
                  checkDefaultForType(
                      schema.definitions.$point_system.properties[item].type,
                      "enum" in schema.definitions.$point_system.properties[item]
                          ? schema.definitions.$point_system.properties[item].enum
                          : undefined
                  )
                : null;
    });

    return defaults;
});

export const panelsDefaultValues = memoize(({ schema }) => {
    let defaults = {};

    Object.keys(schema.definitions.$panels.properties).map(item => {
        defaults[item] =
            checkRenderForProvider(
                item,
                schema.definitions.$panels.properties
            ) &&
            schema.definitions.$panels.properties[item] &&
            "default" in schema.definitions.$panels.properties[item]
                ? (schema.definitions.$panels.properties[item].convert
                    ? schema.definitions.$panels.properties[item].default / 100
                    : schema.definitions.$panels.properties[item].default) ||
                checkDefaultForType(
                    schema.definitions.$panels.properties[item].type
                )
                : null;
    });

    return defaults;
});
